import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import NewsSiderTitle from '../../../../components/newsSiderTitle';
import NewsSiderContent from '../../../../components/newsSiderContent';

class BookList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { nav, data },
        } = this.props;

        const len = nav.length - 1;

        return (
            <div>
                <NewsSiderTitle type={1} content={nav.slice(0, len)}>
                    <a className={styles.donate} href={nav[len].url} target="_blank">
                        <img src={nav[len].src} title={nav[len].title} />
                    </a>
                </NewsSiderTitle>
                <NewsSiderContent content={data} />
            </div>
        );
    }
}

export default errorBoundary(BookList);
